import { Injector } from '@angular/core';
import { ApplicationService } from '../../../services/application/application.service';
import { FormatterService } from '../../../services/formatter/formatter.service';
import { ParserService } from '../../../../../common/angular-shared/services/parser/parser.service';
import { PredicateService } from '../../../services/predicate/predicate.service';

export abstract class ViewModel {
  protected appSvc: ApplicationService;
  protected formatterSvc: FormatterService;
  protected parserSvc: ParserService;
  protected predicateSvc: PredicateService;
  constructor(protected injector: Injector) {
    this.appSvc = this.injector.get(ApplicationService);
    this.formatterSvc = this.injector.get(FormatterService);
    this.parserSvc = this.injector.get(ParserService);
    this.predicateSvc = this.injector.get(PredicateService);
  }

  protected deriveParser(property) {
    let parserType = null;

    try {
      parserType = this.appSvc.getObjectType(property);
      const rules = this.appSvc.getRulesForProperty(property);
      const prominentParserRule = this.appSvc.getFirstTypeRuleFromRules(rules);

      if (prominentParserRule) {
        parserType = this.parserSvc.deriveParserTypeFromRule(prominentParserRule);
      }
    } catch (e) {
      //tslint:disable-next-line
      //TODO: Add proper logging for this exception or fix the exception scenario
    }

    return parserType;
  }

  protected deriveFormatter(property) {
    let formatterType = null;
    try {
      formatterType = this.appSvc.getObjectType(property);
      const rules = this.appSvc.getRulesForProperty(property);
      const prominentFormatterRule = this.appSvc.getFirstTypeRuleFromRules(rules);

      if (prominentFormatterRule) {
        formatterType = this.formatterSvc.deriveFormatterTypeFromRule(prominentFormatterRule);
      }
    } catch (e) {
      //tslint:disable-next-line
      //TODO: Add proper logging for this exception or fix the exception scenario
    }

    return formatterType;
  }
}
